import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { Sun, Brain, Moon, Leaf } from 'lucide-react';
const benefits = [{
  icon: Sun,
  text: 'Recupera tu energía matutina sin depender del café'
}, {
  icon: Brain,
  text: 'Despídete de la neblina mental en menos de 2 semanas'
}, {
  icon: Moon,
  text: 'Duerme profundo y despierta descansada desde el día 7'
}, {
  icon: Leaf,
  text: 'Reduce la hinchazón y los antojos con menús diseñados para ti'
}];
export const BenefitsSection = () => {
  return <Section bg="bg-white" data-id="element-30">
      <FadeIn data-id="element-31">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-32">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-brown mb-6 leading-tight" data-id="element-33">
            Lo que{' '}
            <span className="text-gold italic font-normal" data-id="element-34">recuperarás</span>
          </h2>
        </div>
      </FadeIn>

      <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 max-w-4xl mx-auto" data-id="element-35">
        {benefits.map((benefit, idx) => <StaggerItem key={idx} data-id="element-36">
            <div className="bg-cream-light border border-cream-dark rounded-3xl p-6 md:p-7 flex items-center gap-4 md:gap-5 shadow-sm hover:shadow-md transition-shadow h-full" data-id="element-37">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-sage-light/50 flex items-center justify-center shrink-0" data-id="element-38">
                <benefit.icon className="w-6 h-6 md:w-7 md:h-7 text-sage" data-id="element-39" />
              </div>
              <p className="text-base md:text-lg text-brown font-medium leading-relaxed" data-id="element-40">
                {benefit.text}
              </p>
            </div>
          </StaggerItem>)}
      </StaggerContainer>
    </Section>;
};